import React from 'react';
import HomeContainer from 'features/Home';

// display homepage
const HomePage = () => <HomeContainer />;

export default HomePage;
